/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

import React from 'react';
import { VStack } from 'chakra-v3';
import HelpQrCodeSection from './HelpQrCodeSection';
import HelpInfoSection from './HelpInfoSection';

interface HelpMobileMenuProps {
  whatsappChatbotUrl?: string;
  whatsappWebUrl?: string;
}

/**
 * HelpMobileMenu component displays the help page layout for mobile viewports.
 * It shows a QR code section and an info section stacked vertically.
 * This component is only visible on small and medium screens (below lg breakpoint).
 *
 * @param whatsappChatbotUrl - The WhatsApp chatbot URL to encode in the QR code
 * @param whatsappWebUrl - The WhatsApp Web URL for the link in the info section
 *
 * @example
 * ```tsx
 * <HelpMobileMenu
 *   whatsappChatbotUrl="https://wa.me/1234567890"
 *   whatsappWebUrl="https://web.whatsapp.com"
 * />
 * ```
 */
const HelpMobileMenu: React.FC<HelpMobileMenuProps> = ({ whatsappChatbotUrl, whatsappWebUrl }) => (
  <VStack gap={{ base: 6, md: 8 }} display={{ base: 'flex', md: 'flex', lg: 'none' }} w="100%">
    <HelpQrCodeSection qrCodeValue={whatsappChatbotUrl} />
    <HelpInfoSection whatsappWebUrl={whatsappWebUrl} />
  </VStack>
);

export default HelpMobileMenu;
